export class UnicodeParser {
  public static readonly glyphsMap = {
    'ü': '&#252;',
    'ä': '&#228;',
    'ö': '&#246;',
    'Ü': '&#220;',
    'Ä': '&#196;',
    'Ö': '&#214;',
    'ß': '&#223;',
    'à': '&#224;',
    'À': '&#192;',
    'â': '&#226;',
    'Â': '&#194;',
    'è': '&#232;',
    'È': '&#200;',
    'é': '&#233;',
    'É': '&#201;',
    'ê': '&#234;',
    'Ê': '&#202;',
    'ë': '&#235;',
    'Ë': '&#203;',
    'î': '&#238;',
    'Î': '&#206;',
    'ï': '&#239;',
    'Ï': '&#207;',
    'ô': '&#244;',
    'Ô': '&#212;',
    'ù': '&#249;',
    'Ù': '&#217;',
    'û': '&#251;',
    'Û': '&#219;',
    'ÿ': '&#255;',
    'Ÿ': '&#159;',
    'ç': '&#231;',
    'Ç': '&#199;',
    'œ': '&#156;',
    'Œ': '&#140;',
    '«': '&#171;',
    '»': '&#187;',
    '‹': '&#139;',
    '›': '&#155;',
    '“': '&#147;',
    '”': '&#148;',
    '‘': '&#145;',
    '’': '&#146;',
    'ʼ': '&#8217;',
    '—': '&#151;',
    '–': '&#150;',
    '€': '&#128;',
    '¼': '&#188;',
    '⅓': '&#8531;',
    '½': '&#189;',
    '⅔': '&#8532;',
    '¾': '&#190;',
    '°': '&#176;',
    '̈': '&#0308;',
    '\\': '&#x5c;',
    'ó': '&#243;',
    '„': '&#8222;',
    'ú': '&#250;',
    'Ú': '&#218;',
    '‚': '&#8218;',
    '‐': '&#8208;',
    ' ': '&#160;',
    ' ': '&#8194;',
    ' ': '&#8195;',
    ' ': '&#8196;',
    ' ': '&#8197;',
    ' ': '&#8198;',
    ' ': '&#8199;',
    ' ': '&#8200;',
    ' ': '&#8201;',
    ' ': '&#8202;',
    ' ': '&#8239;',
    ' ': '&#8287;',
    '　': '&#12288;',
  };

  public static readonly unicodeMap = Object.fromEntries(
    Object.entries(UnicodeParser.glyphsMap).map((x) => x.reverse())
  );

  static replaceGlyphs(text: string): string {
    text = text.normalize('NFC');

    return text.split('').map(letter => letter in this.glyphsMap ? this.glyphsMap[letter] : letter).join('');
  }

  static replaceUnicode(text: string): string {
    return text.replace(/&#\d*;/g, (match) => this.unicodeMap[match]);
  }
}
